<template>
  <BaseAvatar v-if="avatar"  :image="avatar" />
  <BaseAvatar v-else-if="userId && !isLoading" :image="fetchedUserAvatar" />
  <BaseAvatar v-else-if="userId && isLoading" />
  <BaseAvatar v-else />
</template>

<script lang="ts" setup>
import useGetUserAvatar from '@/composables/useGetUserAvatar'
import BaseAvatar from '@/components/base/BaseAvatar.vue'

const props = defineProps({
  userId: {
    type: String,
    default: null,
  },
  avatar: {
    type: String,
    required: false,
    default: null,
  }
})

const { data: fetchedUserAvatar, isLoading } = useGetUserAvatar(props.userId)

</script>
